import { Component, Injector, OnDestroy, } from '@angular/core';
import { Destroyable$, IColumnPk, SystemGuid } from 'webcommon/shared';
import { ColumnExtFindcontrolDto } from './ColumnExtFindcontrolDto';
import { ApColumnBase } from '../ap-configurable-table/ap-configurable-column/ap-column-base';
import { ApFindControlModalService, FindControlMode } from '../public-api';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface AutocompleteGroup {
  AdditionalRows: boolean;
  isCollapsable: boolean;
  isCollapsed: boolean;
  GroupDisabled: boolean;
  Name: string;
  ItemList: IColumnPk[];
}
@Component({
  selector: 'ap-column-ext-findcontrol',
  templateUrl: './ap-column-ext-findcontrol.component.html',
  styleUrls: ['./ap-column-ext-findcontrol.component.less'],
})

export class ApColumnExtFindControlComponent extends ApColumnBase<ColumnExtFindcontrolDto> implements OnDestroy, Destroyable$  {
  readonly onDestroy$: Subject<void> = new Subject<void>();

  name = '';
  loading = true;
  findData: IColumnPk[] = [];
  autocompleteGroups: AutocompleteGroup[];
  hideDropdown = true;
  listerAdded = false;

  constructor(
    private apFindControlModalService: ApFindControlModalService,
    private elementInjector: Injector,
    private systemGuid: SystemGuid,
  ) {
    super();
    this.loading = true;
  }

  takeUntilDestroy<T>() {
    return (source: Observable<T>): Observable<T> => {
      return source.pipe(
        takeUntil(this.onDestroy$),
      );
    };
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  load(): void {
    this.loading = true;
    this.findData = this.columnInfoDto.GetExtFindControlCallback(this.dataItem) as IColumnPk[];
    if (this.findData && this.findData.length > 0) {
      this.name = this.findData[0].Name;
    }
    const groups: AutocompleteGroup[] = [];
    if (this.findData && this.findData.length > 0 && this.findData[0].Name.length > 0) {
      const group: AutocompleteGroup =
      {
        AdditionalRows: false,
        isCollapsable: true,
        isCollapsed: false,
        GroupDisabled: true,
        ItemList: this.findData,
        Name: ' Currently Selected ',
      };
      groups.push(group);
    }
    if (this.columnInfoDto.GetDropdownItems) {
      let chips: IColumnPk[] = [];
      chips = this.columnInfoDto.GetDropdownItems;
      if (this.findData && this.findData.length > 0 && this.findData[0].Pk !== this.systemGuid.GuidEmpty) {
        chips = chips.filter((x) =>  x.Pk !== this.findData[0].Pk );
      }

      const group: AutocompleteGroup = {
        AdditionalRows: false,
        isCollapsable: false,
        isCollapsed: false,
        GroupDisabled: false,
        ItemList: chips,
        Name: this.columnInfoDto.groupName,
      };
      groups.push(group);
    }
    this.autocompleteGroups = groups;
    this.loading = false;
  }

  getFormattedName(data: any): string {
    const name = data.Name;
    if (name) {
      return name;
    }
    return '';
  }

  changeDropdown(data: any) {
    const t = data.target.parentElement.innerText.trim();
    if (this.columnInfoDto.GetDropdownItems) {
      let selected =  { resultValue: [{Name: '', Pk: this.systemGuid.GuidEmpty}]};
      const item = this.columnInfoDto.GetDropdownItems.find((x) => x.Name === t );
      if (item) {
        selected =  { resultValue: [{Name: item.Name, Pk: item.Pk}]};
        if (this.findData && this.findData.length > 0 &&
          this.findData[0].Name.trim().length > 0 && this.findData[0].Name.trim() === t) {
            selected =  { resultValue: [{Name: '', Pk: this.systemGuid.GuidEmpty}]};
        }
      }
      this.onFindControlChange(selected);
    }
    this.autocompleteGroups.forEach((x) => { x.isCollapsed = true; });
    this.hideDropdown = true;
  }

  onHideDropdown() {
    this.hideDropdown = true;
  }

  toggleCollapsed( group: any) {
    group.isCollapsed = !group.isCollapsed;
  }

  clickName() {
    if (!this.dataItem.IsDelete && !this.columnInfoDto.IsReadOnly) {
      this.hideDropdown = false;
      if (!this.listerAdded) {
        const id = this.Id + '-Input';
        const el = document.getElementById(id);
        if (el) {
          this.listerAdded = true;
          el.addEventListener('mouseleave', this.onHideDropdown.bind(this));
        }
      }
    }
  }

  clickIcon() {
    if (!this.dataItem.IsDelete && !this.columnInfoDto.IsReadOnly) {
      this.openFindControlModal();
    }
  }

  openFindControlModal() {
    let chips: IColumnPk[] = [];
    chips = this.findData;

    this.apFindControlModalService.openModal (
      this.elementInjector,
      this.columnInfoDto.findControlId,
      chips,
      this.Id,
      this.columnInfoDto.findControlDisplayName,
      FindControlMode.SingleSelect,
      undefined,
      undefined,
      undefined,
    ).pipe(takeUntil(this.onDestroy$)
    ).subscribe (
      (result) => {
        if (result.isSuccess) {
          this.onFindControlChange(result);
        }
      }
    );
  }

  onFindControlChange(data: any) {
    const foundData = data.resultValue;
    const result = {dataItem: this.dataItem, foundData};

    return this.columnInfoDto.Change(result);
  }
}
